import { render, staticRenderFns } from "./SocialIcons.vue?vue&type=template&id=b3adb3ac&scoped=true"
import script from "./SocialIcons.vue?vue&type=script&lang=js"
export * from "./SocialIcons.vue?vue&type=script&lang=js"
import style0 from "./SocialIcons.vue?vue&type=style&index=0&id=b3adb3ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3adb3ac",
  null
  
)

export default component.exports